import { AxiosInstance, AxiosResponse } from 'axios';
import { LoginFormParams } from '../../../views/auth/components/login/LoginForm';
import { SignUpFormParams } from '../../../views/auth/components/signup/SignUpForm';
import {
  ForgotPasswordParams,
  ForgotPasswordResponse,
  ForgotUsernameParams,
  GetVerificationParams,
  LoginResponse,
  RequestOtpBody,
  RequestOtpParams,
  RequestOtpResponse,
  ResetPasswordParams,
  VerificationStatusDTO,
  VerifyOtpBody,
  VerifyOtpParams,
} from '../../types/apiType';

export default class AuthService {
  constructor(private axios: AxiosInstance) {}

  login = async (params: LoginFormParams): Promise<LoginResponse> => {
    const { data } = await this.axios.post('auth/login', params);
    return data;
  };

  requestOtp = async (params: RequestOtpParams): Promise<RequestOtpResponse> => {
    const body: RequestOtpBody = {
      type: params.type,
    };
    if (params.email) {
      body.email = params.email;
    } else if (params.username) {
      body.username = params.username;
    }
    const { data } = await this.axios.post('auth/request-otp', body);
    return data;
  };

  verifyOtp = async (params: VerifyOtpParams): Promise<string> => {
    const body: VerifyOtpBody = {
      otp: params.otp,
      expiredTime: params.expiredTime,
    };
    if (params.email) {
      body.email = params.email;
    } else if (params.username) {
      body.username = params.username;
    }

    const { data } = await this.axios.post('auth/verify-otp', body);
    return data;
  };

  signUp = async (params: SignUpFormParams): Promise<null> => {
    const { data } = await this.axios.post('auth/signup', params);
    return data;
  };

  checkVerificationStatus = async (params: GetVerificationParams): Promise<AxiosResponse<VerificationStatusDTO[]> | any> => {
    const { data } = await this.axios.get('auth/verification', { params });
    return data;
  };

  forgotUsername = async (params: ForgotUsernameParams): Promise<string> => {
    const { data } = await this.axios.post('auth/forgot-username', params);
    return data;
  };

  forgotPassword = async (params: ForgotPasswordParams): Promise<ForgotPasswordResponse> => {
    const { data } = await this.axios.post('auth/forgot-password', params);
    return data;
  };

  refreshToken = async (): Promise<{ token: string }> => {
    const { data } = await this.axios.post('auth/refresh-token');
    return data;
  };

  resetPassword = async ({ password, confirmPassword, token }: ResetPasswordParams): Promise<null> => {
    const { data } = await this.axios.put(
      'auth/reset-password',
      {
        password,
        confirmPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return data;
  };
}
